<div>
    <span>{{title}}</span>
    <mat-slider thumbLabel tickInterval="1" [min]="1" [max]="maxValue" class="long-width-slider" [disabled]="disabled"
        showTickMarks>
        <input matSliderThumb [value]="value" (change)="handleThumbInput($event)" #slider>
    </mat-slider>
    <span>{{slider.value}}</span>
</div>